module.exports = __webpack_public_path__ + "img/collaborate_24.15c5bc0e.jpg";